// for general Cards:
export const QUANTITIES = [20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340, 350, 360, 370, 380, 390, 400];
export const QUANTITY_OPTIONS = QUANTITIES.map(quantity => ({ label: quantity.toString(), value: quantity }));
export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';

export const ALL_FILTER_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW'
];

// for Customization:
export const ORDERED_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'DETAILS',
  'MENU',
  'PROGRAM',
  'THANK_YOU',
  'RSVP',
  'RSVP_ENVELOPE',
  'INVITATION_ENVELOPE',
  'ENVELOPE'
];

export const PRIMARY_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'DETAILS',
  'MENU',
  'PROGRAM',
  'THANK_YOU'
];

export const CUSTOMIZATION_BAR_DROPDOWN_SECTIONS = [
  {
    label: 'FRONT',
    description: 'Print on the front (required)',
    step: 'detailFront'
  },
  {
    label: 'BACK',
    description: 'Print on the back',
    step: 'detailBack'
  },
  {
    label: 'GUESTS',
    description: 'Add guest addressing',
    step: 'recipients'
  },
  {
    label: 'ENVELOPE',
    description: 'Print your return address',
    step: 'envelope'
  },
  {
    label: 'RSVP CARD',
    description: 'Add RSVP cards & envelopes',
    step: 'rsvp'
  },
  {
    label: 'RSVP ENVELOPE',
    description: 'Print mailing address',
    step: 'rsvpEnvelope'
  }
];

export const INVITES_PRODUCT_TYPES = ['INVITATION', 'RSVP', 'SAVE_THE_DATE', 'THANK_YOU'];
export const TEXT_ALIGNMENT_OPTIONS = ['LEFT', 'CENTER', 'RIGHT'];
export const BACK_PRINTING_PRICE = 35;

// these are the option values that must be present in the variation.option_values
// object of a customization for it to get updated by the customization bar
export const REQUIRED_OPTION_VALUE_KEYS = ['silhouette', 'paper-type'];

export const CARD_TYPE = {
  INVITATION: {
    type: 'INVITATION',
    urlSlug: 'invitations',
    label: 'Invitations',
    isLead: true
  },
  SAVE_THE_DATE: {
    type: 'SAVE_THE_DATE',
    urlSlug: 'save-the-date',
    label: 'Save The Dates',
    isLead: true
  },
  THANK_YOU: {
    type: 'THANK_YOU',
    urlSlug: 'thank-you-cards',
    label: 'Thank You Cards',
    isLead: true
  },
  MENU: {
    type: 'MENU',
    urlSlug: 'menus',
    label: 'Menus',
    isLead: true
  },
  PROGRAM: {
    type: 'PROGRAM',
    urlSlug: 'programs',
    label: 'Programs',
    isLead: true
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: 'enclosures',
    label: 'Enclosures',
    isLead: true
  },
  RSVP: {
    type: 'RSVP',
    urlSlug: null, // secondary card type, no slug.
    label: 'RSVP',
    isLead: false
  },
  ENVELOPE: {
    type: 'ENVELOPE',
    urlSlug: null, // secondary card type, no slug.
    label: 'Envelope',
    isLead: false
  }
};

export const SIZE_OPTIONS_COPY = {
  petite: '4.25 x 5.5 in.',
  postcard: '4.25 x 5.5 in. (does not include envelope)',
  '5x7': '5.0 x 7.0 in.'
};

export const ENABLED_SAMPLE_ORDER_CARD_TYPES = ['INVITATION', 'SAVE_THE_DATE'];

export const PAGES = ['FRONT', 'BACK', 'RSVP', 'RSVP ENVELOPE', 'ENVELOPE'];
export const PAGE_URLS = {
  FRONT: 'detailFront',
  BACK: 'detailBack',
  RSVP: 'rsvp',
  'RSVP ENVELOPE': 'rsvpEnvelope',
  ENVELOPE: 'envelope'
};

export const PROJECT_COPY_MAP = {
  INVITATION: {
    title: 'Wedding Invitation'
  },
  SAVE_THE_DATE: {
    title: 'Save the Date'
  },
  THANK_YOU: {
    title: 'Thank You Card'
  },
  MENU: {
    title: 'Menu'
  },
  DETAILS: {
    title: 'Enclosure Card'
  },
  PROGRAM: {
    title: 'Program Card'
  }
};

// for PLP:
export const ALL_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW'
];
export const HERO_COPY = {
  INVITATION: {
    header: 'Wedding Invitations',
    subheader: 'Made Easy',
    description: 'Discover a design you love, then personalize your invites in minutes.'
  },
  SAVE_THE_DATE: {
    header: 'Save the Dates',
    subheader: '',
    description:
      'Set the tone for your special day and make your guests excited to celebrate.'
  },
  DETAILS: {
    header: 'Enclosure Cards',
    subheader: '',
    description: 'Share all your extra wedding details, from attire to accommodations.'
  },
  MENU: {
    header: 'Menus',
    subheader: '',
    description:
      'Give guests a gorgeous dining experience with designs that match your suite.'
  },
  PROGRAM: {
    header: 'Wedding Programs',
    subheader: '',
    description: 'Beautifully show off your ceremony details, wedding party, and more.'
  },
  THANK_YOU: {
    header: 'Thank You Cards',
    subheader: '',
    description:
      'Send your gratitude in style, and get personal with a custom wedding photo.'
  },
  DRAPER_JAMES: {
    header: 'Zola x Draper James',
    subheader: '',
    description:
      ' Inspired by Reese Witherspoon’s Southern roots, Draper James <em>always</em> brings the style (no matter your location on the map).'
  }
};



// WEBPACK FOOTER //
// ./src/cards/constants/Cards.js